import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';

// components

import { HeaderNav, NavBar } from 'app-components';
import GAChatLink from './GAChatLink';

// selectors

import { environmentSelector } from '@selectors/commonSelectors';
import { selectPartner, selectBroker } from '@selectors/dashboardLiteSelectors';

// constants

import { languageTypes } from '@constants/common/languageTypes';
import Logo from '@components/common/headers/fragments/Logo';

// Actions
import { showModal } from '@actions/common/actionCreators';

//Types
import { ssapModalTypes as MODAL_TYPES } from '@constants/ssap/modals/ssapModalTypes';

// props

interface GAEPSubMenuProps {
    isLoggedIn?: boolean;
    environment: any;
    // onHandleSelect: (eventKey: any) => void;
}

const GASubMenu = (props: GAEPSubMenuProps) => {

    const {
        isLoggedIn=true,
        environment
    } = props;

    const {
        stateCode,
        links: {
            HOME: GA_WP_HOME,
            LOGO_URL:logoUrl,
            HELP: helpUrl,
            logoMobile,
            logoUrlMobile,
            micrositeIds,
            logoUrl: carrierLogoUrl,
            PHONE

        }
    } = useSelector(environmentSelector);

    const dispatch: Dispatch<any> = useDispatch();

    const EXTERNAL_HOST = 'https://georgiaaccess.gov/';
    const EXTERNAL_URL = {
        GET_COVERED: EXTERNAL_HOST + 'get-covered/',
        GET_CONSUMER_LINK: EXTERNAL_HOST + 'learn-more/',
        GET_PARTNER_LINK: EXTERNAL_HOST + 'for-partners/enhanced-direct-enrollment-partners/',
        GET_AGENTS_LINK: EXTERNAL_HOST + 'for-partners/agents/',
        GET_FAQ_LINK: helpUrl,
        GET_GENERAL_INFO_LINK: EXTERNAL_HOST + 'for-partners/',
        GET_CONTACT_US_LINK : EXTERNAL_HOST + 'find-assistance/',
        GET_ABOUT_US_LINK : EXTERNAL_HOST + 'about-georgia-access/'
    };
    

    const partner = useSelector(selectPartner);
    const broker = useSelector(selectBroker);
    const lang = sessionStorage.language && sessionStorage.language === languageTypes.SPANISH_STR ? languageTypes.SPANISH : languageTypes.ENGLISH;
    const GA_LOGO = global.__ENV__.PRODUCTION ? '/hix/resources/img/logo_ga.png' : '/assets/images/logo_ga.png';

    const onClickFindLocalAssistantHandler = () => {
        dispatch(showModal({
            modalType: MODAL_TYPES.LOCATE_ASSISTANCE_MODAL,
            modalData: {
                customEvent: 'close_LocateAssistanceModal'
            }
        }));
    };

    const NotLoggedInMenu = () => {
        return (
            <>
                <NavBar hasCloseButton={true}>
                    <NavBar.Item>
                        <NavBar.Link id='get_covered_menu' url={EXTERNAL_URL.GET_COVERED} labelId='gaep.menu.get_covered' isShowInNewTab={true}/>
                    </NavBar.Item>
                    <NavBar.Item>
                        <NavBar.Menu id='resources_menu' labelId='gaep.menu.resources'>
                            <NavBar.SubMenuItem id='for_consumers_link' url={EXTERNAL_URL.GET_CONSUMER_LINK} labelId='gaep.menu.resources.for_consumers' isShowInNewTab={true} />
                            <NavBar.SubMenuItem id='for_partners_link' url={EXTERNAL_URL.GET_PARTNER_LINK} labelId='gaep.menu.resources.for_partners' isShowInNewTab={true} />
                            <NavBar.SubMenuItem id='for_agents_link' url={EXTERNAL_URL.GET_AGENTS_LINK} labelId='gaep.menu.resources.for_agents' isShowInNewTab={true} />
                            <NavBar.SubMenuItem id='faqs_link' url={EXTERNAL_URL.GET_FAQ_LINK} labelId='gaep.menu.resources.faqs' isShowInNewTab={true} />
                            <NavBar.SubMenuItem id='general_info_link' url={EXTERNAL_URL.GET_GENERAL_INFO_LINK} labelId='gaep.menu.resources.gen_info' isShowInNewTab={true} />
                        </NavBar.Menu>
                    </NavBar.Item>
                    <NavBar.Item>
                        <NavBar.Menu id='support_menu' labelId='gaep.menu.support'>
                            <GAChatLink environment={environment} />
                            <NavBar.SubMenuItem id='contact_us_link' url={EXTERNAL_URL.GET_CONTACT_US_LINK} labelId='gaep.menu.support.contact_us' isShowInNewTab={true} />
                            <NavBar.SubMenuActionItem id='find-local-assistant-link' labelId='gaep.menu.support.local_assistance' onClickHandler={onClickFindLocalAssistantHandler} />
                        </NavBar.Menu>
                    </NavBar.Item>
                    <NavBar.Item>
                        <NavBar.Link id='about' url={EXTERNAL_URL.GET_ABOUT_US_LINK} labelId='gaep.menu.about' isShowInNewTab={true}/>
                    </NavBar.Item>
                </NavBar>
            </>
        );
    };

    const LoggedInMenu = () => {
        return (
            <>
                <NavBar>
                    <NavBar.Item>
                        <NavBar.Link id='faqs' url={EXTERNAL_URL.GET_FAQ_LINK} labelId='common.faqs' />
                    </NavBar.Item>
                    {
                        !partner && !broker &&
                       <NavBar.Item>
                           <NavBar.Link id='contact_num' ariaLabel={'Contact us'} url={`tel:${PHONE}`} label={PHONE} />
                       </NavBar.Item>
                    }
                </NavBar>
            </>
        );
    };
    
    return (
        <HeaderNav isTopNav={false} stateCode={stateCode} hasSubMenu={true}>
            <div className="usa-navbar gi-navbar">
                <Logo { ...{ logo: GA_LOGO, logoUrl, logoMobile, stateCode, name, carrierLogoUrl: GA_LOGO, logoUrlMobile, micrositeIds } }/>
            </div>
            {
                isLoggedIn && <LoggedInMenu />
            }
            {
                !isLoggedIn && <NotLoggedInMenu />
            }
        </HeaderNav>
    );
};

export default GASubMenu;